import {mapActions, mapMutations, mapGetters} from 'vuex';

import {required, maxLength, minLength} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";

export default {
  name: 'stores.edit',
  mixins: [validationMixin],
  data() {
    return {
      translations: [],
      currentTranslations: 0,
      validationErrors: {},
    }
  },
  components: {},
  validations: {
    translations: {
      $each: {
        title: {
          required,
          minLength: minLength(1),
          maxLength: maxLength(20)
        },
        description: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(60)
        }
      }
    }
  },
  created() {
    let storeId = parseInt(this.$route.params.storeId);
    if (!this.store || this.store.id !== storeId) {
      this.fetchStore(storeId).then(()=>{
        this._applyData();
      });
    } else {
      this._applyData();
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      store: 'stores/store',
      isStoreLoading: 'stores/isStoreLoading',
      isStoreUpdating: 'stores/isStoreUpdating',
    }),
    ...mapGetters([
      'languages',
    ]),
  },
  methods: {
    ...mapActions({
      fetchStore: 'stores/STORE_REQUEST_DATA_GET',
      editStore: 'stores/STORE_REQUEST_UPDATE',
    }),
    ...mapMutations({}),
    _applyData() {
      this.translations = this.languages.map(langItem => {
        let lang = this.store.translations.data.filter(translationItem => {
          return translationItem.locale === langItem.translationKey;
        })[0];

        let translationItem = {
          locale: langItem.translationKey,
          title: '',
          description: '',
        }

        if (lang) {
          translationItem = Object.assign(translationItem, {
            title: lang.title,
            description: lang.description,
          })
        }
        return translationItem
      });
    },
    translationsTitleErrors(index) {
      let error = [];
      if (!this.$v.translations.$each[index].title.$dirty) {
        return error;
      }
      if (!this.$v.translations.$each[index].title.required) {
        error.push(this.$t('validationRequired'));
      }
      if (!this.$v.translations.$each[index].title.minLength) {
        error.push(this.$t('validationMin',{count: 1}));
      }
      if (!this.$v.translations.$each[index].title.maxLength) {
        error.push(this.$t('validationMax',{count: 20}));
      }
      return error;
    },
    translationsDescriptionErrors(index) {
      let error = [];
      if (!this.$v.translations.$each[index].description.$dirty) {
        return error;
      }
      if (!this.$v.translations.$each[index].description.required) {
        error.push(this.$t('validationRequired'));
      }
      if (!this.$v.translations.$each[index].description.minLength) {
        error.push(this.$t('validationMax',{count: 2}));
      }
      if (!this.$v.translations.$each[index].description.maxLength) {
        error.push(this.$t('validationMax',{count: 60}));
      }
      return error;
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let payload = {};
        this.translations.forEach(item => {
          payload[item.locale] = {
            title: item.title,
            description: item.description,
          }
        });
        this.editStore({
            storeId: this.store.id,
            payload: payload
          }).then(() => {
            this.$toasted.success(this.$t('dataUpdated'));
            this.$router.push({name: 'stores.list'}).catch(() => {console.log();});
        }).catch(error => {
          if (error.response.status === 422) {
            this.$toasted.error(error.response.data.message);
            this.validationErrors = error.response.data.errors
          }
        });
      }
    }
  }
}
